/**
 * 历史跟进记录
 * @author tylerzzheng
 */
import { useEffect, useMemo } from 'react'
import { ExtendItem, HistoryFollowListFilter, HistoryFollowListItem, sortTypeEnum } from '@types'
import { useService, useShowError } from '@hooks'
import { getTouchStatus } from '@services/lead'
import { parseExtend, parseFollowExtend } from '@library'
import { getHistoryFollowList } from '@services/customer'
import { useTableService } from '@hooks/useTableService'
import { clone } from 'lodash'

export type HistoryFollowData = HistoryFollowListItem & {
  extendObj?: {[key: string]: any},
  extendArr?: ExtendItem[],
  touchStatus?: string
  intention?: string
  followType?: string
  competingExpirationProductsObj?: { productId: string, productName: string }[]
}
export function useFollowList (customerId: number) {
  /**
   * 历史跟进记录
   */
  const initRecordFilter = useMemo<HistoryFollowListFilter>(() => ({
    page: 1,
    pageSize: 5,
    sort: 'createTime',
    sortType: sortTypeEnum.DESC,
    customerId,
  }), [customerId])

  const {
    loading,
    list,
    pagination,
    filter,
    setFilter,
    reload,
    rowKey,
  } = useTableService(getHistoryFollowList, initRecordFilter, '获取历史跟进记录失败')

  useEffect(() => {
    setFilter({ customerId })
  }, [customerId])

  const [touchLoading, touchRes, touchErr] = useService(getTouchStatus)
  useShowError('获取触达状态列表失败', touchErr)

  const historyFollowList: HistoryFollowData[] = useMemo(() => list.map(item => {
    const historyFollowData: any = clone(item)
    historyFollowData.extendObj = parseFollowExtend(item?.extend)
    historyFollowData.extendArr = parseExtend(item?.extend)
    historyFollowData.intention = `${item.intentionName}-${item.subIntentionName}`
    historyFollowData.touchStatus = touchRes?.list?.find?.(t => +t.key === +item.touchStatus)?.value
    historyFollowData.followType = item.followType.join?.(',')
    return historyFollowData
  }), [list, touchRes])

  return [
    loading || touchLoading,
    historyFollowList,
    pagination,
    filter,
    setFilter,
    reload,
    rowKey,
  ] as const
}
